import moment from 'moment';

const now = moment();

/* Setup default */
export const datepicker = {
    now: now,
    start_date: now.subtract(1, "days").format('DD/MM/YYYY'),
    now_format: now.add(1, "days").format('DD/MM/YYYY'),
    now_format_end: now.add(1, "years").format('DD/MM/YYYY')
};

/* Options language "es" */
export const options = {
    type: 'day',
    week: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do'],
    month: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    format: 'DD/MM/YYYY',
    placeholder: '',
    inputStyle: {
        'display': 'inline-block',
        'padding': '6px',
        'line-height': '22px',
        'font-size': '16px',
        'border': '2px solid #fff',
        'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
        'border-radius': '2px',
        'color': '#5F5F5F'
    },
    color: {
        header: '#3F51B5',
        headerText: '#fff'
    },
    buttons: {
        ok: 'Aceptar',
        cancel: 'Cancelar'
    },
    overlayOpacity: 0.5,
    dismissible: true
};


// WEBPACK FOOTER //
// ./src/config/datepicker.js